<template>
  <div class="other-meeting-list">
    <el-container style="background: white;">
      <el-header style="padding: 0;">
        <!-- 顶部tab切换 -->
        <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
          <el-tab-pane
            v-for="(tab, index) in tabList"
            :key="index"
            :label="tab.label"
            :name="tab.name"
          ></el-tab-pane>
        </el-tabs>
        <el-form
          :model="queryForm"
          :inline="true"
          label-width="80px"
          style="padding-right: 20px;"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="会议时间：">
                <el-date-picker
                  v-model="queryForm.meetingDate"
                  type="date"
                  placeholder="-请选择-"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="会议地点：">
                <el-input
                  v-model="queryForm.meetingRoom"
                  clearable
                  placeholder="-请输入-"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="会议类别：">
                <el-select
                  v-model="queryForm.meetingType"
                  placeholder="-请选择-"
                  clearable
                >
                  <!-- type.value是展示用的，type.label是给后台传参的 -->
                  <el-option
                    v-for="(type, index) in meetingTypeList"
                    :key="index"
                    :label="type.value"
                    :value="type.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div class="search-btns">
                  <el-button type="primary" icon @click="handleSearch"
                    >查询</el-button
                  >
                  <el-button type="info" icon @click="resetSearch"
                    >重置</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="createOtherMeeting"
              v-if="btnAuthorize.addBtn.btnEnable"
              >新增</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-refresh-left"
              @click="callbackOtherMeeting"
              v-if="btnAuthorize.callback.btnEnable"
              >撤回</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="editOtherMeeting"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              >修改</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-delete"
              @click="deleteOtherMeeting"
              v-if="btnAuthorize.delBtn.btnEnable"
              >删除</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main>
        <el-table
          :data="tableData"
          ref="meetingTableRef"
          border
          size="mini"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="gotoDetail"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            prop="startTime"
            label="会议时间"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="room"
            label="会议地点"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="title"
            label="会议主题"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="会议类别" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                class="type-item"
                v-for="(item, index) in scope.row.typeMapNameList"
                :key="index"
                >{{ item }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="提报日期"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { tabList, getOtherStatus } from "./variables";
import Constants from "@/utils/consts";
import {
  deleteConference,
  getConferenceList,
  callbackConference,
  getOtherConferenceTypeList
} from "@/services/conferenceServices";
export default {
  name: "OtherMeetingList",
  data() {
    return {
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        callback: { key: "callback", btnEnable: false }, //撤回
      },
      tabList: tabList,
      activeName: "first",
      queryForm: {
        meetingDate: undefined,
        meetingRoom: undefined,
        meetingType: undefined
      },
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [], // 返回的列表数据
      selectedItems: [],
      meetingType: 2, // "其他类型会议".这个类型跟queryForm里的meetingType不一样。这里用来区分“综合”还是“其他”。
      meetingTypeList: [] // “其他类型会议”中的会议类型
    };
  },
  methods: {
    onActive(menuCode) {
      this.activeName = "first";
      this.currentPage = 1;
      this.getMeetingTypeList();
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getList();
    },
    getMeetingTypeList() {
      //获取“会议类别”的选择项
      getOtherConferenceTypeList()
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.meetingTypeList = res.data || [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getList() {
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        workDate: this.queryForm.meetingDate
          ? this.queryForm.meetingDate.toLocaleDateString().replaceAll("/", "-")
          : undefined,
        room: this.queryForm.meetingRoom,
        type: this.meetingType,
        status: getOtherStatus(this.activeName),
        category: this.queryForm.meetingType
      };
      getConferenceList(params)
        .then(res => {
          if (res.code == Constants.Code_OK) {
            let list = res.data || [];
            list.forEach(item => {
              // 将回包的数据，会议类型整理一下，方便table输出
              let { typeMap } = item;
              item.typeMapNameList = [];
              item.typeMapKeyList = [];
              for (let key in typeMap) {
                item.typeMapKeyList.push(key);
                item.typeMapNameList.push(typeMap[key]);
              }
            });
            this.tableData = list;
            this.totalCount = res.total || 0;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {});
    },
    handleTabClick() {
      // 切换tab
      this.currentPage = 1;
      this.getList();
    },
    handleSearch() {
      console.log("-- search", this.queryForm);
      this.currentPage = 1;
      this.getList();
    },
    resetSearch() {
      this.currentPage = 1;
      this.queryForm.meetingDate = undefined;
      this.queryForm.meetingRoom = undefined;
      this.queryForm.meetingType = undefined;
      this.getList();
    },
    createOtherMeeting() {
      this.bus.$emit("navMenuChange", {
        routeId: "createOtherMeeting"
      });
    },
    callbackOtherMeeting() {
      //撤回会议,每次只能一项
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      this.$confirm("你确定要撤回该会议吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return callbackConference({ conferenceId: this.selectedItems[0].id });
        })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.getList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(() => {});
    },
    editOtherMeeting() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      let target = this.selectedItems[0];
      // 修改必须先执行撤回操作.这里要验证状态
      if (target.status != 2) {
        this.$alert("该会议当前不能修改", "提示");
        return;
      }
      this.bus.$emit("navMenuChange", {
        routeId: "editOtherMeeting",
        routeParam: {
          id: target.id
        }
      });
    },
    deleteOtherMeeting() {
      // 删除会议。每次只能删除一项
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      this.$confirm("此操作将永久删除已选会议, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return deleteConference({ conferenceId: this.selectedItems[0].id });
        })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.getList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {});
    },
    handleSelectionChange(val) {
      // 选择数据项
      this.selectedItems = val;
    },
    rowClicked(row, event, column) {
      // 点击切换行选中状态
      this.$refs.meetingTableRef.toggleRowSelection(row);
    },
    gotoDetail(row, column, cell, event) {
      // 查看会议详情
      this.bus.$emit("navMenuChange", {
        routeId: "otherMeetingDetail",
        routeParam: {
          id: row.id
        }
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.other-meeting-list {
  height: 100%;
}

/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
/deep/.el-tabs__item:hover {
  color: #069dbc;
}

.search-btns {
  text-align: right;
}

.el-main {
  min-height: 200px;
  height: auto !important;
}

.type-item {
  margin-right: 5px;
  white-space: nowrap;
}
</style>
